import setAuthorizationToken from "../utils/setAuthorizationToken";
import {
  loginUser,
  updateUser,
  getLoggedInUser,
  updateShippingRequest,
  addShippingRequest,
  contactUsRequest,
  updateBillingRequest,
  updatePasswordRequest,
  forgotPasswordRequest,
  resetPasswordRequest,
  mailchimpSubscribeRequest
} from "../services/mightyWifiApi";
import {
  SET_CURRENT_USER,
  SET_LOGGEDIN_USER,
  SET_REDIRECT_PATH
} from "./types";
export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user
  };
}

export function logout() {
  return dispatch => {
    localStorage.removeItem("jwtToken");
    // localStorage.removeItem("sessionId");
    setAuthorizationToken(false);
    dispatch(setCurrentUser({}));
  };
}

export function login(data) {
  return dispatch => {
    var loginPayload = {
      email: data.identifier,
      password: data.password
    };

    return loginUser(loginPayload).then(res => {
      if (res.success) {
        const token = res.token;
        localStorage.setItem("jwtToken", JSON.stringify(res));
        setAuthorizationToken(token);
        dispatch(setCurrentUser(res));
      }
    });
  };
}

export function updateUserRequest(payload) {
  return disptach => {
    return updateUser(payload);
  };
}

export function geCurrentUser(payload) {
  return dispatch => {
    return getLoggedInUser().then(res => {
      dispatch({
        type: SET_LOGGEDIN_USER,
        profile: Object.assign({}, res.data)
      });
    });
  };
}

export function updateShipping(payload) {
  return disptach => {
    return updateShippingRequest(payload);
  };
}

export function updateBilling(payload) {
  return disptach => {
    return updateBillingRequest(payload);
  };
}

export function addShipping(payload) {
  return disptach => {
    return addShippingRequest(payload);
  };
}

export function updatePassword(payload) {
  return disptach => {
    return updatePasswordRequest(payload);
  };
}

export function contactUs(payload) {
  return disptach => {
    return contactUsRequest(payload);
  };
}

export function forgotPassword(payload) {
  return disptach => {
    return forgotPasswordRequest(payload);
  };
}

export function resetPassword(payload) {
  return disptach => {
    return resetPasswordRequest(payload);
  };
}

export function subscribeToMightyWifi(payload) {
  return disptach => {
    return mailchimpSubscribeRequest(payload);
  };
}

export function setRedirectPath(path, payload) {
  return dispatch => {
    dispatch({
      type: SET_REDIRECT_PATH,
      path: path,
      payload: payload
    });
  };
}



// WEBPACK FOOTER //
// ./src/modules/actions/authActions.js